import {BlogPostSearchByPubDateType} from '@nls-2022/nls-bll';
const BlogPostSearchByPubDate = ({
  pubDate,
  handlePubDateSearch,
  children,
}: BlogPostSearchByPubDateType) => {
  return (
    <>
      {children}
      <input
        type="text"
        onChange={handlePubDateSearch}
        value={pubDate}
        aria-label="club-search-active-flag"
      />
    </>
  );
};

export default BlogPostSearchByPubDate;
